<script>
import modalMixin from '@phoenix/mixins/modalMixin';
import Modal from '@maison/components/common/Modal.vue';
import PictureLazy from '@maison/components/common/PictureLazy.vue';
import { PhxIcon } from '@phx-styleguides/jlc';

export default {
  components: {
    Modal,
    PictureLazy,
    PhxIcon,
  },

  mixins: [modalMixin],

  props: {
    chapter: {
      type: Object,
      required: true,
    },
  },
};
</script>

<template>
  <modal
    :id="id"
    :has-footer-slot="false"
    :should-display-header="false"
    :should-wrap-content="false"
    :classes="['video-series-modal']"
    overlay-padded
    :container-classes="['theme-dark']"
  >
    <template #content>
      <header class="video-series-modal__header">
        <slot name="background-video"></slot>

        <div class="video-series-modal__header-infos">
          <div class="video-series-modal__pretitle h6">{{ chapter.preTitle }}</div>

          <h1 class="video-series-modal__title">{{ chapter.title }}</h1>

          <button
            type="button"
            class="btn btn--default btn--sm btn--negative video-series-modal__play-first"
            :data-modal-open="chapter.fullscreenModalId"
            data-episode-index="0"
          >
            <span class="btn__text">{{ $t('InTheMaking.watchFirstEpisode') }}</span>
          </button>
        </div>

        <button
          type="button"
          class="btn btn--default btn--icon-only btn--icon modal__close btn--sm"
          :data-modal-close="chapter.modalId"
        >
          <span class="sr-only">{{ $t('Button.close') }}</span>

          <span class="btn__icon">
            <phx-icon icon="cross-16" />
          </span>
        </button>
      </header>

      <main class="video-series-modal__content">
        <div class="video-series-modal__description">{{ chapter.longDesc }}</div>

        <h2 class="video-series-modal__category-title">
          {{ $t('InTheMaking.chapterEpisode', { nbrEpisode: chapter.episodes.length }) }}
        </h2>

        <ul class="video-series-modal__episodes">
          <div
            v-for="(episode, index) in chapter.episodes"
            :key="index"
            class="card card--horizontal video-series-modal__episode"
            data-cy="video-series-episode"
          >
            <div class="card__media">
              <div class="picture picture--cover">
                <picture-lazy v-bind="episode.image" />
              </div>

              <div class="card__media-icon">
                <phx-icon icon="play-16" class="icon--sm" />
              </div>
            </div>

            <div class="card__text-content">
              <div class="card__header">
                <div class="card__title h5">{{ episode.title }}</div>

                <div class="card__detail">{{ episode.duration }}</div>
              </div>

              <div class="card__body">
                <div class="card__truncate">{{ episode.longDesc }}</div>
              </div>

              <button
                type="button"
                class="btn btn--link btn--icon card__button expand-target"
                :data-modal-open="chapter.fullscreenModalId"
                :data-episode-index="index"
              >
                <span class="btn__text">{{ $t('InTheMaking.watchNow') }}</span>

                <span class="btn__icon">
                  <phx-icon icon="chevron-10" bidirectional />
                </span>
              </button>
            </div>
          </div>
        </ul>
      </main>

      <slot name="footer"></slot>
    </template>
  </modal>
</template>
